import { useCallback, RefObject } from 'react';

interface UseVideoFullscreenOptions {
  videoRef: RefObject<HTMLVideoElement>;
}

interface UseVideoFullscreenReturn {
  handleFullscreen: () => void;
}

export function useVideoFullscreen(options: UseVideoFullscreenOptions): UseVideoFullscreenReturn {
  const { videoRef } = options;

  // Handle fullscreen toggle — iOS Safari doesn't support requestFullscreen()
  // on video elements, so fall back to webkitEnterFullscreen()
  const handleFullscreen = useCallback(() => {
    const video = videoRef.current;
    if (!video) return;

    if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if ((video as HTMLVideoElement & { webkitEnterFullscreen?: () => void }).webkitEnterFullscreen) {
      (video as HTMLVideoElement & { webkitEnterFullscreen: () => void }).webkitEnterFullscreen();
    }
  }, [videoRef]);

  return {
    handleFullscreen,
  };
}
